import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';

export const oktaAuthGuard: CanActivateFn = async () => {
  const oktaAuth = inject(OKTA_AUTH);
  const router = inject(Router);

  const isAuthenticated = await oktaAuth.isAuthenticated();
  if (isAuthenticated) {
    // const claims = await oktaAuth.getUser();
    // console.log('[okta] user claims (pick a field for the header username):', claims);
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};

export const redirectIfAuthenticatedGuard: CanActivateFn = async () => {
  const oktaAuth = inject(OKTA_AUTH);
  const router = inject(Router);

  const isAuthenticated = await oktaAuth.isAuthenticated();
  if (isAuthenticated) {
    return router.createUrlTree(['/bidding']);
  }

  return true;
};
